import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFrameworkMethodsPropType } from 'ui-components/prop-types/modal-framework-methods';

import * as Actions from '../../../../store/customers/combine/customers.combine.actions';
import Global from '../../../../store/global-selectors';
import { emptyArray } from 'ui-components/default-props/empty';
import messages from './messages';
import style from './combine-customers-confirmation-modal.module.less';

export const CombineCustomersConfirmationModal = React.memo(({ modalFrameworkMethods }) => {
  const dispatch = useDispatch();
  const selectedCustomersCount = useSelector(Global.selectSelectedCustomersCount) || 0;
  const selectedCustomerIds = useSelector(Global.selectSelectedCustomersIds) || emptyArray;
  const { closeModal } = modalFrameworkMethods;

  const handleCancel = useCallback(() => {
    closeModal();
    dispatch(Actions.closeCombineCustomersConfirmationModal());
  }, [closeModal, dispatch]);

  const handleConfirmClick = useCallback(() => {
    dispatch(Actions.combineCustomers(selectedCustomerIds));
  }, [dispatch, selectedCustomerIds]);

  return (
    <Modal className={style['combine-customers-confirmation-modal']} size='medium'>
      <ModalHeader className={style['combine-customers-confirmation-modal-header']} closeModal={closeModal}>
        <FormattedMessage {...messages.title} />
      </ModalHeader>
      <ModalBody className={style['combine-customers-confirmation-modal-body']}>
        <FormattedMessage {...messages.body} values={{ customersCount: selectedCustomersCount }} />
      </ModalBody>
      <ModalFooter className={style['combine-customers-confirmation-modal-footer']}>
        <Button onClick={handleCancel} theme='tertiary'>
          <FormattedMessage {...messages.cancel} />
        </Button>
        <Button onClick={handleConfirmClick} theme='primary'>
          <FormattedMessage {...messages.confirm} />
        </Button>
      </ModalFooter>
    </Modal>
  );
});

CombineCustomersConfirmationModal.propTypes = {
  modalFrameworkMethods: ModalFrameworkMethodsPropType.isRequired,
};
